export default __webpack_public_path__ + "static/realWorldImg1-652d2b6635ad117b3f440748013871f6.png";